<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <div class="f-right border-b">
            <div class="flex1">巡查区域管理</div>
            <!-- v-hasPermi="['safe:safearea:edit']" -->
            <el-button icon="el-icon-plus" type="primary" @click="addList()" v-hasPermi="['relic:relicInspectionCompanyArea:addAndUpdate']"
              v-show="cpNum!=''">新增</el-button
            >
            <!-- v-hasPermi="['safe:safearea:edit']" -->
            <el-button
              class="ml10"
              type="primary"
              v-hasPermi="['relic:relicInspectionCompanyArea:addAndUpdate']"
              @click="onSubmit"
              v-show="cpNum!=''"
              >保存</el-button
            >
          </div>
           
          <div style="display:flex" class="">
           <div
              style="width: 20%"
              v-show="!($store.state.user.userInfo.natureId == 2)"
            >
              <unitList
                @select="getUnit"
                @getFirst="getOne"
                style="margin-top: 20px"
              ></unitList>
            </div>
            <table class="common-table mt20" height="100%">
              <thead>
                <tr class="mt10">
                  <th>巡查区域</th>
                  <th>操作</th>
                  <!-- v-hasPermi="['safe:safearea:edit']" -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in listWW" :key="index" >
                  <td class="common-add">
                    <el-input
                      placeholder="请输入"
                      v-model="item.areaName"
                    ></el-input>
                  </td>

                  <td class="td-btn">
                    <el-popconfirm
                      title="确定删除此项吗？"
                      class="cursor"
                      icon="icon-tr-delete"
                      @onConfirm="del1(index, item)"
                    >
                      <i
                        class="icon-tr-delete"
                        slot="reference"
                        v-hasPermi="[
                          'relic:relicInspectionCompanyArea:areaRemoveExist',
                        ]"
                      ></i>
                    </el-popconfirm>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-backtop target=".common-body-style"></el-backtop>
  </div>
</template>

<script>
import unitList from "@/components/unitList1";
export default {
  data() {
    return {
      list: [],
      listWW: [],
      tabList: this.$store.state.user.userInfo.isWenwu
        ? [{ name: "文物巡查", id: 1 }]
        : [{ name: "消防巡查", id: 0 }],

      nowIndex: 0,

      list1: [{ start_time: "", z_status: 1 }],
      cpNum: null,
    };
  },
  components: {
    unitList,
  },
  created() {
    // this.getList();
    this.getDatas();
  },
  methods: {
    getOne(v) {
      console.log(v);
      this.cpNum = v;
      console.log("getOne");
      this.getWWlist();

    },
    getUnit(v) {
      console.log(v);
      this.cpNum = v;
      console.log("getUnit");

      this.getWWlist();
    },
    changeTab(index, it) {
      this.nowIndex = index;
      this.getDatas();
    },
    onSubmit() {
      for (let i = 0; i < this.listWW.length; i++) {
        console.log(this.listWW[i].areaName, "this.listWW[i].areaName");
        if (this.listWW[i].areaName == "") {
          this.$message({
            message: "巡查项不可为空",
            type: "warning",
            duration: 700,
          });
          return;
        } else if (this.listWW[i].areaName != undefined) {
        } else {
          this.$message({
            message: "巡查项不可为空",
            type: "warning",
            duration: 700,
          });
          return;
        }
      }

      console.log(this.listWW);
      let companyNum = this.cpNum||this.$store.state.user.company.cCompanyNum || "";
      this.$post(
        `/relic/relicInspectionCompanyArea/addAndUpdate?companyNum=${companyNum}`,
        this.listWW
      ).then((res) => {
        this.getDatas();

        this.$message({
          message: "操作成功",
          type: "success",
          duration: 700,
        });
      });

      // if (this.$store.state.user.userInfo.isWenwu) {
      console.log(this.listWW);
      // this.$post("/xuncha/add", { get_area: this.listWW }).then((res) => {
      //   this.getDatas();

      //   this.$message({
      //     message: "操作成功",
      //     type: "success",
      //     duration: 700,
      //   });
      // });
      // } else {
      //   this.$post("/xuncha/xcareaadd", { get_area: this.list }).then((res) => {
      //     this.getDatas();

      //     this.$message({
      //       message: "操作成功",
      //       type: "success",
      //       duration: 700,
      //     });
      //   });
      // }
    },
    onSubmit1() {
      //    return
      this.$post("/xuncha/xctimeadd", { get_time: this.list1 }).then((res) => {
        this.$message({
          message: "操作成功",
          type: "success",
          duration: 700,
        });
      });
    },
    check() {
      var checked = true;

      if (this.list.length) {
        this.list.map((item) => {
          if (!item.x_company_id) {
            this.nowIndex = 0;
            this.$message.warning("请输入唯一标识");
            checked = false;
          }
        });

        return checked;
      } else {
        return checked;
      }
    },
    getDatas() {
      // if (this.tabList[this.nowIndex].id == 0) {
      //   this.getList();
      // } else {
      this.getWWlist();
      // }
    },
    getWWlist() {
      let companyNum = this.cpNum||this.$store.state.user.company.cCompanyNum || "";
      this.$get(
        "/relic/relicInspectionCompanyArea/listNotPage?companyNum=" +companyNum
      ).then((res) => {
        console.log(res);
        this.listWW = res.data;
      });
    },
    getList() {
      // getUserList(this.params).then(res=>{
      //     this.total = res.data.count
      //     this.list = res.data.list
      // }).catch(err=>{

      // })
      this.$post("/xuncha/xunchaareadetail", {
        c_company_num: this.$store.state.user.company.cCompanyNum,
      }).then((res) => {
        console.log(res);
        this.list = res.data;
      });
      // this.$post('/xuncha/xunchatimedetail').then(res=>{
      //               // return
      //               this.list1=res.data || []

      //           })
    },
    del(index) {
      if (this.list[index].x_company_id) {
        var x_company_id = this.list[index].x_company_id;
        // this.$post('/xuncha/xcareaExist', { x_company_id, inspectionType: 1 }).then((res) => {
        //   if (res.code < 1000) {
        //     if (res.data == false) {
        //       this.list.splice(index, 1);
        //     } else {
        //       this.$message.warning(res.msg);
        //     }
        //   }
        // });
      } else {
        this.list.splice(index, 1);
      }
    },
    del1(index, item) {
      console.log(item, this.listWW[index], "inex");
      if (this.listWW[index].areaId) {
        var x_company_id = item.areaId;
        this.$get(
          "/relic/relicInspectionCompanyArea/areaRemoveExist/" + x_company_id
        )
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.listWW.splice(index, 1);
              this.$message.success(res.msg);
            } else if (res.code == 201) {
              this.$message.warning(res.msg);
              // this.listWW.splice(index, 1);
            } else {
            }
          })
          .catch((error) => {
            // console.log(error);
            // this.$message.warning(error.data.msg);
          });
      } else {
        this.listWW.splice(index, 1);
      }
    },
    addList() {
      // if (this.tabList[this.nowIndex].id == 0) {
      //   this.list.unshift({ x_company_area: "" });
      // } else {
      this.listWW.unshift({ areaId: null });
      // }
    },
    addList1() {
      this.list1.push({ start_time: "", z_status: 1 });
    },
  },
};
</script>

<style></style>
